import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Device, DeviceCart, DeviceFeature, Role} from '@kion/data-models';

@Component({
  selector: 'kion-feature-quote-list',
  templateUrl: './feature-quote-list.component.html',
  styleUrls: ['./feature-quote-list.component.scss']
})
export class FeatureQuoteListComponent {

  @Input() deviceCart: DeviceCart;
  @Input() device: Device;
  @Input() roles: Role[];
  @Input() features: DeviceFeature[];
  @Input() disableDelete = false;
  @Input() disableHealthyCheck = false;

  // tslint:disable-next-line:no-output-rename
  @Output('deleteFeature') deleteFeatureClickedEmitter: EventEmitter<number> = new EventEmitter<number>();

  deleteFeatureClicked(entryNumber: number) {
    this.deleteFeatureClickedEmitter.emit(entryNumber);
  }
}
